import moment from 'moment'

import { useSchedule } from '../../../hooks/ScheduleContext'

import { AddBlockButton } from './Buttons/AddBlockButton'
import { CalendarOptionsButton } from './Buttons/CalendarOptionsButton'
import { PreSchedulingButton } from './Buttons/PreSchedulingButton'
import { TaxiDogButton } from './Buttons/TaxiDogButton'
import { ServiceQueueButton } from './Buttons/ServiceQueueButton'
import { ScheduleFilter } from './ScheduleFilter'

import {
  Container,
  Controls,
  DateBox,
  ButtonBox,
  ActionButton,
  Title,
} from './styles'
import { Slider } from './Slider'
import { HeaderDateSelect } from './HeaderDateSelect'
import { useThemes } from '../../../providers/theme'
import SelectGap from './SelectGap'
import { useMerchant } from '../../../store/global/useMerchant'
import { motion } from "framer-motion";
import { useMenu } from '../../../store/global/useMenu'

export function Header() {
  const merchant = useMerchant((st) => st.data.merchant);
  const menuSize = useMenu(st => st.data.size)

  const { updateConfig, getConfig } = useSchedule()
  const { theme } = useThemes()

  const config = getConfig()

  const setToday = () => {
    const today = moment().format('YYYY-MM-DD')
    if (today === config.date) return
    updateConfig({ date: today })
  }

  const handleFilter = (filterData) => {
    // Implementar lógica de filtro na agenda
    console.log('Filtros aplicados:', filterData)
    // Aqui você pode atualizar o contexto da agenda com os filtros
    updateConfig({ filters: filterData })
  }

  const handleClearFilter = () => {
    // Limpar filtros da agenda
    console.log('Filtros limpos')
    updateConfig({ filters: null })
  }

  return (
    <motion.div
      initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
      animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
      transition={{ duration: 0.3 }}
    >
      <Container className='w-full pr-4'>
        <HeaderDateSelect />
        <Controls>
          <DateBox>
            <ActionButton size="100px" onClick={setToday}>
              Hoje
            </ActionButton>
            <Title>{moment(config.date).format('LL')}</Title>
            <Slider />
            <SelectGap />
          </DateBox>
          <ButtonBox>
            {theme === 'draMei' && <ServiceQueueButton />}
            {theme === 'petland' && <TaxiDogButton />}
            {theme === 'petland' && <AddBlockButton />}
            {theme === 'petland' && !!merchant.hasTokenVarejo && <PreSchedulingButton />}
          </ButtonBox>
          <ScheduleFilter
            onFilter={handleFilter}
            onClear={handleClearFilter}
          />
        </Controls>
      </Container>
    </motion.div>

  )
}
